const MAX_ID = 2147483647; // int32 — o que a API aceita em `id`

/** "#412" ou "412" (1..int32) viram filtro de id; qualquer outro texto vira busca por título. */
export function parseSearch(text: string): { q?: string; id?: number } {
  const trimmed = text.trim();
  if (!trimmed) return {};
  const match = /^#?(\d+)$/.exec(trimmed);
  if (match) {
    const id = Number(match[1]);
    if (id >= 1 && id <= MAX_ID) return { id };
  }
  return { q: trimmed };
}
